export default __webpack_public_path__ + "375b39b472c751386ee7bdd865ce6d1a.svg";